import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MagnifyingGlass } from '@phosphor-icons/react';
import telegramService from '../services/telegram';
import Logo from './Logo';

/**
 * Шапка главной. Используется только в Home.jsx.
 *
 * Знак слева, поиск справа. Аватар, имя и счётчик «в сохраненных» убраны:
 * вход в профиль и сердце уже есть в нижнем меню.
 */
const Header = () => {
  const navigate = useNavigate();

  const handleSearchClick = () => {
    telegramService.hapticFeedback('light');
    navigate('/search');
  };

  return (
    <header className="bg-theme-bg z-sticky">
      <div className="max-w-app mx-auto px-4 py-3 flex items-center justify-between">
        {/* Охранное поле вокруг знака — не менее высоты «n», брендбук 4.3 */}
        <Logo height={22} className="text-theme-text-primary" />

        <button
          onClick={handleSearchClick}
          className="p-2 -mr-2 hover:opacity-70 transition-opacity duration-fast"
          aria-label="Открыть поиск"
        >
          <MagnifyingGlass size={24} className="text-action" />
        </button>
      </div>
    </header>
  );
};

export default Header;
